import { useState } from "react";
import _ from "lodash";

const useSearch = () => {

    const [searchValue, setSearchValue] = useState('');

    const setValue = (value) => {
        setSearchValue(value);
    }

    const filterByObjectKeys = (obj) => {
        if(!_.isEmpty(obj) && !_.isEmpty(searchValue)) {
            let res = {};
            Object.keys(obj).forEach((value) => {
                if(value.toUpperCase().includes(searchValue.toUpperCase()))
                    res[value] = obj[value];
            })
            return res;
        }
        return obj;
    }

    const filterList = (list, key) => {
        if(!_.isEmpty(list) && !_.isEmpty(key)) {
            let filtered = list.filter(item => {
                return !_.isEmpty(item[key]) && item[key].toUpperCase().includes(searchValue.toUpperCase());
            });
            return filtered;
        }
    }

    const filterListMultiColumn = (list, key) => {
        if(!_.isEmpty(list) && !_.isEmpty(key)) {
            let filtered = list.filter(item => {
                let flag = key.map(keyItem => {
                   return !_.isEmpty(item[keyItem]) && item[keyItem].toUpperCase().includes(searchValue.toUpperCase());
                })
                return flag.includes(true);
            });
            return filtered;
        }
    }

    const clearValue = () => {
        setSearchValue('');
    }

    let response = {}
    response.searchValue = searchValue;
    response.setSearchValue = setValue;
    response.clearValue = clearValue;
    response.filterList = filterList;
    response.filterListMultiColumn = filterListMultiColumn;
    response.filterByObjectKeys = filterByObjectKeys;
    return response;
}

export default useSearch;